<!-- Modal_Window -->
<div class="shared-modal-wrapper" *ngIf="isShowModal">
  <a
    href="javascript:;"
    class="modal-overlay">
  </a>

  <div class="modal-window">
    <div class="modal-content">
      <div class="modal-cancel" (click)="onCloseModal()"></div>

      <h2 class="text-message" *ngIf="message" [innerHTML]="message"></h2>

      <div class="btn-group">
        <button
          type="button"
          class="abtn back_btn"
          (click)="onCloseModal()">
          <p>{{ (messageClose ||'MILEAGE.MD_MESSAGE_BTN_LABEL') | translate }}</p>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- //Modal_Window -->
